import React from 'react';
import { createPortal } from 'react-dom';
import MagicButton from 'components/MagicButton/MagicButton';
import './DeleteConfirmModal.css';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  articleTitle: string;
  isDeleting: boolean;
}

const DeleteConfirmModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
  articleTitle,
  isDeleting
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return createPortal(
    <div className="delete-confirm-modal-backdrop" onClick={handleBackdropClick}>
      <div className="delete-confirm-modal">
        <div className="delete-confirm-modal-header">
          <h2>Delete Article?</h2>
          <button className="delete-confirm-modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="delete-confirm-modal-body">
          <p className="delete-confirm-warning">
            This action cannot be undone. This will permanently delete:
          </p>
          <p className="delete-confirm-article-title">"{articleTitle}"</p>
          <p className="delete-confirm-note">
            All content, images, and metadata will be removed.
          </p>
        </div>

        <div className="delete-confirm-modal-actions">
          <MagicButton
            label="Cancel"
            onPress={onClose}
            color="grey"
            isDisabled={isDeleting}
          />
          <button
            className="delete-confirm-button"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete Article'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeleteConfirmModal;
